export default __webpack_public_path__ + "static/media/ttzlb.6b5e21e5.png";